import { Divider, SxProps } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { SubmitOrderSection } from './SubmitOrderSection'
import { OrderItemsGrid } from './OrderItemsGrid'
import { OrderSummary } from './OrderSummary'
import { PromotionCode } from './PromotionCode'

interface OrderReviewProps {
  acceptPromoCode?: boolean
  direction?: 'row' | 'column'
  readonly?: boolean
  containerSx?: SxProps
}

export const OrderReview = ({
  acceptPromoCode,
  direction,
  readonly,
  containerSx,
}: OrderReviewProps) => {
  const { t } = useTranslation()
  return (
    <SubmitOrderSection label={t('Order summary')} sx={containerSx}>
      <OrderItemsGrid
        sx={{ marginBottom: 2 }}
        direction={direction}
        readonly={readonly}
      />
      <Divider />
      {acceptPromoCode && <PromotionCode sx={{ marginTop: 1.5 }} />}
      <OrderSummary sx={{ marginTop: 1.5 }} showTip={true} />
    </SubmitOrderSection>
  )
}
